<template>
    <div class="home pt-0 mt-0">
        <Carousel />
        <v-divider class="azul" />
        <Banners />
        <v-divider class="azul" />
        <Contact />
    </div>
</template>

<script>
import Carousel from '../components/Carousel';
import Banners from '../components/Banners';
import Contact from '../components/Contact-home';

export default {
    name: 'Home',
    components: {
        Carousel,
        Banners,
        Contact
    }
};
</script>
